<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title">
          <div class="text-center">عنوان {{ history.Title }}</div>
        </v-card-title>
        <div>
          <div style="padding: 15px">
            <template v-if="history.ShahrestanName != ''">
              <v-row align="center">
                <v-col class="d-flex">
                  <b>شهر محل سکونت:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="content">
                  <span v-html="history.ShahrestanName"></span>
                </v-col>
              </v-row>
            </template>
            <template v-if="history.D_Priority != ''">
              <v-row align="center">
                <v-col class="d-flex">
                  <b>اولویت های طلبه:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="content">
                  <span v-html="history.D_Priority"></span>
                </v-col>
              </v-row>
            </template>
            <v-row align="center">
              <v-col class="d-flex">
                <b>ملاحظات طلبه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.Description"></span>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر مدرسه: </b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.Des_School"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر ستاد تبلیغ: </b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.Des_Setad"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر حراست: </b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.Des_Herasat"></span>
              </v-col>
            </v-row>
            <div style="padding: 5px"></div>
          </div>
        </div>
        <app-row title="تاریخ مصاحبه:" :value="history.D_Mosahebe" />
        <app-row title="ساعت مصاحبه:" :value="history.T_Mosahebe" />
        <app-row title="مکان مصاحبه:" :value="history.P_Mosahebe" />
        <v-row v-if="history.D_Mosahebe === ''" class="ltr">
          <v-btn
            color="red white--text"
            class="register"
            rounded
            @click="$emit('removeRequest', history)"
          >
            حذف درخواست
          </v-btn>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { convertHTMLBody } from "@/utils/constants";

export default {
  props: ["history"],
  components: {
    appRow: DetailRow,
  },
  methods: {
    convertDesc() {
      return convertHTMLBody(this.history.Description);
    },
  },
};
</script>
